export default __webpack_public_path__ + "static/media/Icon metro-qrcode.08db3e7b.svg";